export const GoodsType = {
    // 装扮
    DRESS_UP: 1,
    // 皮肤
    SKIN: 2,
    // 道具
    PROP: 3,
}

export const PropType = {
    // 重置券
    RESET: 'RESET',
    // 礼物
    GIFT: 'GIFT',
    // 次数卷
    NUM: "NUM",
    // 挑战卷
    PK: "PK",
    // 延迟锁课卷
    DELAY: "LOCK_TIME_DELAY",
}

// 道具使用状态
export const AssetStatus = {
    // 未使用
    UNUSE: 0,
    // 已使用
    USED: 1,
}